const buttonCompCalendar = {
  filter: 'filtros'
};

export default buttonCompCalendar;
